import React from "react"
import type { FieldValues, SubmitHandler, UseFormProps } from "react-hook-form"
import { FormProvider } from "react-hook-form"

import type { YupSchema } from "./hooks"
import { useFormWithSchema } from "./hooks"

interface FormProps<TFieldValues extends FieldValues = FieldValues>
    extends Omit<UseFormProps<TFieldValues>, "resolver"> {
    readonly children: React.ReactNode
    readonly schema: YupSchema<TFieldValues>
    readonly onSubmit: SubmitHandler<TFieldValues>
    readonly testId?: string
}

export default function Form<TFieldValues extends FieldValues>({
    children,
    onSubmit,
    schema,
    testId,
    ...useFormProps
}: FormProps<TFieldValues>) {
    const methods = useFormWithSchema<TFieldValues>({
        schema,
        ...useFormProps,
    })

    return (
        <FormProvider {...methods}>
            <form
                onSubmit={methods.handleSubmit(onSubmit)}
                data-testid={testId}
            >
                {children}
            </form>
        </FormProvider>
    )
}
